import React, { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, Box, TextField, InputAdornment } from "@mui/material";
import "../../style/style.css";
import { useJoinNowContext } from "../../Context/joinNowContext";
import CrossSvg from "../../svg/crossSvg";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';


function PersonalInformation() {
  const ArrowSvg = () => (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30" className={`transition-transform duration-300 ${isModalOpen ? "rotate-0" : "rotate-180"}`}>
    <path data-name="Path 68504" d="M30 0H0v30h30z" style={{ fill: "none", opacity: .87 }} />
    <path data-name="Path 68505" d="m18.414 16.975-4.919-4.919-4.919 4.919a1.264 1.264 0 0 1-1.788-1.788l5.819-5.819a1.263 1.263 0 0 1 1.788 0l5.819 5.819a1.263 1.263 0 0 1 0 1.788 1.29 1.29 0 0 1-1.8 0z" transform="translate(1.505 1.468)" style={{ fill: "#fff" }} />
  </svg>
  )
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    step,
    setStep,
    identity,
    setCNICNumber,
    dob,
    setDob,
    gender,
    setGender,
    referral,
    setReferral,
  } = useJoinNowContext();

  const [errors, setErrors] = useState({
    CNICNumber: "",
    dob: "",
    gender: "",
    referral: "",
  });


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "CNICNumber") {
      let rawValue = value.replace(/-/g, ""); // Remove any existing dashes
      if (rawValue.length > 5) {
        rawValue = rawValue.slice(0, 5) + "-" + rawValue.slice(5); // Insert first dash after 5 digits
      }
      if (rawValue.length > 13) {
        rawValue = rawValue.slice(0, 13) + "-" + rawValue.slice(13); // Insert second dash after 7 more digits
      }
      setCNICNumber(rawValue.slice(0, 15));
      const CnicRegex = /^[\d-]+$/;
      if (!CnicRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          CNICNumber: "CNIC/Passport must be a number ",
        }));
      } else if (rawValue.length < 15) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          CNICNumber: "CNIC must have 13 number ",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          CNICNumber: "",
        }));

      }

    } else if (name === "referral") {
      const refferralRegex = /^\d+$/;
      if (!refferralRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          referral: "Invalid number",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          referral: "",
        }));

      }
      setReferral(value.slice(0, 6));
    }
  };

  const Submit = () => {

    setStep(step + 1);

  };

  const handleOpenModal = () => setIsModalOpen(!isModalOpen);

  const handleGenderChange = (gender) => {
    setGender(gender) // Close modal after selecting gender
  };

  const handleClearField = (field: string) => {
    if (field === 'CNICNumber') setCNICNumber('');

    if (field === 'referral') setReferral('');

    setErrors(prevErrors => ({ ...prevErrors, [field]: '' }));
  };
  console.log("tghis si sdob", dob)
  const isButtonDisabled = Object.values(errors).some((error) => error !== "") || !gender;
  const handleDateChange = (newValue: Dayjs | null) => {
    if (newValue) {
      setDob(newValue.toDate()); // Convert Dayjs to Date
    }
  };

  return (
    <div className="step1 w-[90%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[600px] rounded-[4px] bg-[#303030] m-auto item-center justify-center">
      <h1 className="lg:text-lg text-left text-base text-white w-full">Personal Information</h1>
      <Box
        component="form"
        sx={{ "& > :not(style)": { m: 2, width: "100%" } }}
        noValidate
        autoComplete="on"
      >
        <TextField
          id="CNICNumber"
          name="CNICNumber"
          label="CNIC/Passport Number"
          variant="standard"
          value={identity}
          onChange={handleChange}
          error={!!errors.CNICNumber}
          helperText={errors.CNICNumber}
          InputProps={{
            endAdornment: errors.CNICNumber ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("CNICNumber")} /> {/* Conditionally render CrossSvg */}
              </InputAdornment>
            ) : <span className="bg-none px-3 py-1 otem-center rounded-[6px] text-white text-xs ">{"(optional)"} </span>
          }}
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              label="Date of birth"
              name="Date of birth"
              value={dayjs(dob)}
              onChange={handleDateChange}
              sx={{
                '& .MuiOutlinedInput-root': {
                  // Remove the default fieldset
                  '& fieldset': {
                    display: 'none',
                  },
                  // Apply a white border only to the bottom (in all states)
                  borderBottom: '1px solid #bbbbbb', // Bottom border all the time
                  '&:hover': {
                    borderBottom: '1px solid #bbbbbb', // Ensure white border stays on hover
                  },
                  '&.Mui-focused': {
                    borderBottom: '1px solid #bbbbbb', // Ensure border stays white on focus
                  },
                  // Set border radius to zero
                  borderRadius: '0', // Zero border radius
                },
                '& .MuiInputBase-input': {
                  color: 'white', // Text inside input should be white
                },
                '& .MuiFormLabel-root': {
                  color: 'white', // Label color should be white
                },
                // Targeting the icon color
                '& .MuiSvgIcon-root': {
                  color: 'white', // Set the calendar icon color to white
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>




        <div className="w-full mt-5">
          {/* Gender Field */}
          <div
            className="border-b border-gray-300 flex flex-row mt-7 justify-between bg-[#303030] w-full py-1 text-left cursor-pointer"
            onClick={handleOpenModal}
          >

            <p className="text-white text-semibold">{" Gender"}</p>
            <ArrowSvg />
          </div>

          {/* Modal */}
          {isModalOpen && (
            <div className="bg-[#3d3d3d] w-full mt-2 p-4 rounded-md">
              <div>
                {/* Radio Button: Male */}
                <label className="flex items-center mb-4 cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="Male"
                    checked={gender === "male"}
                    onChange={() => handleGenderChange("male")}
                    className="hidden peer"
                  />
                  <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`w-3 h-3 text-white ${gender === "male" ? "block" : "hidden"} transition-opacity duration-200`}
                      viewBox="0 0 20 20"
                      style={{ fill: '#fff' }}
                    >
                      <g data-name="Group 24954">
                        <path
                          data-name="Path 68503"
                          d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                          transform="translate(-4.373 -3.52)"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="ml-5 text-white">Male</span>
                </label>

                {/* Radio Button: Female */}
                <label className="flex items-center mb-4 cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="Female"
                    checked={gender === "female"}
                    onChange={() => handleGenderChange("female")}
                    className="hidden peer"
                  />
                  <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`w-3 h-3 text-white ${gender === "female" ? "block" : "hidden"} transition-opacity duration-200`}
                      viewBox="0 0 20 20"
                      style={{ fill: '#fff' }}
                    >
                      <g data-name="Group 24954">
                        <path
                          data-name="Path 68503"
                          d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                          transform="translate(-4.373 -3.52)"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="ml-5 text-white">Female</span>
                </label>

                {/* Radio Button: Other */}
                <label className="flex items-center cursor-pointer ">
                  <input
                    type="radio"
                    name="gender"
                    value="Other"
                    checked={gender === "not specified"}
                    onChange={() => handleGenderChange("not specified")}
                    className="hidden peer"
                  />
                  <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`w-3 h-3 text-white ${gender === "not specified" ? "block" : "hidden"} transition-opacity duration-200`}
                      viewBox="0 0 20 20"
                      style={{ fill: '#fff' }}
                    >
                      <g data-name="Group 24954">
                        <path
                          data-name="Path 68503"
                          d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                          transform="translate(-4.373 -3.52)"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="ml-5 text-white">Not Specified</span>
                </label>
              </div>
            </div>
          )}
        </div>
        {/*<TextField
          id="referral"
          name="referral"
          label="Referral Code (optional)"
          variant="standard"
          value={referral}
          onChange={handleChange}
          error={!!errors.referral}
          helperText={errors.referral}
          InputProps={{
            endAdornment: errors.referral ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("referral")} /> 
              </InputAdornment>
            ) : null
          }}
        />*/}
      </Box>
      <div className="flex w-full h-auto justify-end">
      <button
          className={`${isButtonDisabled || (gender === "" || dob === null )
            ? "bg-inherit border border-[#4e4e4e]"
            : "bg-red "
            } text-white py-2 px-6 rounded-[5px] font-bold text-base mt-10`}
          disabled={gender === "" || dob === null  || isButtonDisabled}
          onClick={Submit}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default PersonalInformation;
